module.exports = __webpack_public_path__ + "media/svg/mk-143fff99.svg";